var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#98002E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IMG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IMG_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.876 221.5V173.476H80.652V221.5H90.876Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.466 221.5V173.476H138.066L126.402 203.5L114.738 173.476H100.41V221.5H110.634V186.868L124.17 221.5H128.634L142.17 186.868V221.5H152.466Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.332 222.364C193.972 222.364 200.812 218.836 205.708 213.364V194.932H182.812V203.86H195.484V209.62C193.54 211.42 189.58 213.292 185.332 213.292C176.548 213.292 170.212 206.596 170.212 197.524C170.212 188.452 176.548 181.756 185.332 181.756C190.372 181.756 194.476 184.636 196.708 188.02L205.132 183.412C201.532 177.724 195.268 172.684 185.332 172.684C171.22 172.684 159.7 182.332 159.7 197.524C159.7 212.644 171.22 222.364 185.332 222.364Z",
    fill: "#F9F9F9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.abb26a785c3ab86e4d213bf1fc383ac2.svg";
export { ForwardRef as ReactComponent };